import type { StreetViewMarkerObject as MapStreetViewMarkerObject } from '../../../../common/types';
import CanvasObject from '../CanvasObject';
import type SurfaceBase from '../SurfaceBase';
import type { Point } from '../SurfaceBase';

export default class MarkerObject extends CanvasObject {
  marker: MapStreetViewMarkerObject;

  private point: Point;

  constructor(id: string, surface: SurfaceBase, marker: MapStreetViewMarkerObject) {
    super(id, surface);
    this.marker = marker;
    this.point = this.surface.toScreenCoords({
      lng: marker.geometry.coordinates[0],
      lat: marker.geometry.coordinates[1],
    });
  }

  refreshScreenCoords(): void {
    this.point = this.surface.toScreenCoords({
      lng: this.marker.geometry.coordinates[0],
      lat: this.marker.geometry.coordinates[1],
    });
  }

  drawHitArea(ctx: OffscreenCanvasRenderingContext2D, color: string): void {
    ctx.save();
    const scale = 2 ** (this.surface.map.getZoom() - 19);
    ctx.translate(this.point.x, this.point.y);
    ctx.scale(scale, scale);
    ctx.fillStyle = color;
    ctx.beginPath();
    // the marker is fixed width and height = 72
    ctx.fillRect(0, 0, 72, 72);
    ctx.fill();
    ctx.restore();
  }

  render(ctx: CanvasRenderingContext2D): void {
    ctx.save();
    const scale = Math.min(window.devicePixelRatio || 1, 2);
    ctx.translate(this.point.x, this.point.y);
    ctx.scale(scale, scale);
    ctx.beginPath();
    ctx.globalAlpha = 1;

    const path1 = new Path2D(
      'M18.7 11H11.3C11.1343 11 11 11.1343 11 11.3V20.4845C11 20.7145 11.2482 20.859 11.4482 20.7453L14.8518 18.8115C14.9437 18.7593 15.0563 18.7593 15.1482 18.8115L18.5518 20.7453C18.7518 20.859 19 20.7145 19 20.4845V11.3C19 11.1343 18.8657 11 18.7 11Z',
    );
    const path2 = new Path2D(
      'M10.1621 6.93799C11.1115 6.93799 11.8811 6.16837 11.8811 5.219C11.8811 4.26962 11.1115 3.5 10.1621 3.5C9.21274 3.5 8.44312 4.26962 8.44312 5.219C8.44312 6.16837 9.21274 6.93799 10.1621 6.93799Z',
    );
    const path3 = new Path2D(
      'M12.5643 9.57499L12.5643 9.57499L12.5637 9.569C12.4599 8.65259 11.6956 7.93164 10.7463 7.93164H9.59075C8.66086 7.93164 7.87731 8.63324 7.77323 9.57003L7.77322 9.57003L7.77296 9.57251L7.50671 12.0828C7.45373 12.5267 7.71376 12.9065 8.09525 13.06L8.5595 13.2495L8.87605 17.3037C8.90808 17.8152 9.34948 18.1757 9.81931 18.1757H10.5177C11.0132 18.1757 11.4069 17.7941 11.4591 17.3246L11.4601 17.3157L11.4607 17.3067L11.7654 13.2366L12.2181 13.0518C12.6246 12.9067 12.8686 12.4987 12.8176 12.0828L12.5643 9.57499Z',
    );
    const path4 = new Path2D(
      'M14 11H18.6C18.7657 11 18.9 11.1343 18.9 11.3V20.4845C18.9 20.7145 18.6518 20.859 18.4518 20.7453L15.0482 18.8115C14.9563 18.7593 14.8437 18.7593 14.7518 18.8115L11.3482 20.7453C11.1482 20.859 10.9 20.7145 10.9 20.4845V19.5',
    );

    ctx.fillStyle = '#ffffff';
    ctx.fill(path1);

    ctx.strokeStyle = '#000000';
    ctx.lineWidth = 2;
    ctx.stroke(path2);
    ctx.fillStyle = '#F4C24F';
    ctx.fill(path2);

    ctx.strokeStyle = '#000000';
    ctx.lineWidth = 2;
    ctx.stroke(path3);
    ctx.fillStyle = '#F4C24F';
    ctx.fill(path3);

    ctx.lineCap = 'round';
    ctx.strokeStyle = '#000000';
    ctx.lineWidth = 1;
    ctx.stroke(path4);

    this.surface.resetCanvasTransform(ctx);
  }
}
